import React, { useContext, useEffect, useState } from "react";
import Link from "next/link";
import PropTypes from "prop-types";
import { useAuth } from "@src/auth";
import Drawer from "./Drawer";
import HamburgMenu from "./HamburgMenu";
import { DrawerContext } from "./DrawerContext";
import { TOP_MENU_ITEMS } from "./data";
import ScrollSpyMenu from "./ScrollSpyMenu";
import NavBarLogo from "assets/home/navbar_logo_adjusted.svg";

import styles from './navbar.module.css';

const Navbar = ({
  button,
  navbarStyle,
  logoWrapperStyle,
  row,
  menuWrapper,
  white,
}) => {
  const { user, signOutUser } = useAuth()
  const { state, dispatch } = useContext(DrawerContext);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  const LOGGED_IN_MENU_ITEMS = [
    {
      label: "Home",
      staticLink: true,
      path: "/",
      offset: "70",
    },    
    {
      label: "Applications",
      staticLink: true,
      path: "/candidate/dashboard/applications",
      offset: "70",
    },         
    {
      label: "Auto-Apply",
      staticLink: true,
      path: "/candidate/dashboard/auto",
      offset: "70",
    },     
    {
      label: "AI Cover Letter",
      staticLink: true,
      path: "/candidate/dashboard/coverletter",
      offset: "70",
    },   
    {
      label: "AI Resume",
      staticLink: true,
      path: "/candidate/dashboard/resume",
      offset: "70",
    },            
    {
      label: "Manage Plan",
      staticLink: true,
      path: "/candidate/dashboard/manage",
      offset: "70",
    },            
    {
      label: "Preferences",
      staticLink: true,
      path: "/candidate/dashboard/preferences",
      offset: "70",
    },
    {
      label: "Help Center",
      staticLink: true,
      path: "/help",
      offset: "70",
    },         
    {
      label: "Sign Out",
      offset: "70",
      onClick: () => signOutUser()
    }
  ];  

  // Toggle drawer
  const toggleHandler = () => {
    dispatch({
      type: "TOGGLE",
    });
  };

  return (
    <div className={`${styles.wrap} hosting_navbar`}>
      <div className={styles.container}>
        <Link href="https://www.lifeshack.com">
          <a>
            <div style={logoWrapperStyle}>
              <NavBarLogo />
            </div>
          </a>
        </Link>
        {
          loaded && (
            <ScrollSpyMenu
              className="main_menu"
              menuItems={user ? LOGGED_IN_MENU_ITEMS : TOP_MENU_ITEMS}
              offset={-70}
              white={white}
            />            
          )
        }
        <div className={styles.mobileMenu}> 
          <Drawer
            width="380px"
            placement="right"
            drawerHandler={<HamburgMenu barColor="#eb4d4b" />}
            open={state.isOpen}
            toggleHandler={toggleHandler}
            wrapperClassName="about-drawer"
          >
            <ScrollSpyMenu
              className="mobile_menu"
              menuItems={user ? LOGGED_IN_MENU_ITEMS : TOP_MENU_ITEMS}
              drawerClose={true}
              offset={-100}
              white={white}
            />
          </Drawer>     
        </div>       
      </div>
    </div>
  )
};

Navbar.propTypes = {
  navbarStyle: PropTypes.object,
  logoStyle: PropTypes.object,
  button: PropTypes.object,
  row: PropTypes.object,
  menuWrapper: PropTypes.object,
  logoWrapperStyle: PropTypes.object,
};

Navbar.defaultProps = {
  navbarStyle: {
    className: "hosting_navbar",
    minHeight: "70px",
    display: "block",
  },
  button: {
    type: "button",
    fontSize: "13px",
    fontWeight: "700",
    borderRadius: "4px",
    pl: "15px",
    pr: "15px",
    colors: "secondaryWithBg",
    minHeight: "auto",
    height: "40px",
  },
  logoWrapperStyle: {
    marginRight: "40px",
    position: "relative",
    // top: "-3px"
  },
  row: {
    flexBox: true,
    alignItems: "center",
    justifyContent: [
      "space-between",
      "space-between",
      "space-between",
      "flex-start",
    ],
    width: "100%",
  },
  logoStyle: {
    maxWidth: "130px",
    mr: [0, 0, 0, "166px"],
  },
  button: {
    type: "button",
    fontSize: "13px",
    fontWeight: "600",
    color: "white",
    borderRadius: "4px",
    pl: "15px",
    pr: "15px",
    colors: "primaryWithBg",
    minHeight: "auto",
    height: `${1}`,
  },
  menuWrapper: {
    flexBox: true,
    alignItems: "center",
  },
};

export default Navbar;
